import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, ACCOUNT_TYPES, EMAIL, COUNTRIES_LIST, TABLET_SCREEN_WIDTH, PLAID_BUSINESS_TYPES } from "../../appconstants";
import {
  FlexContainer,
  Hr,
  Input,
  InputWrapper,
  LabelText, PH3Text, SpanText,
  SubmitButton,
  Text
} from "../../design";
import { Alert, Tag, Tooltip } from "antd";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { getLocationDetails, getPlaidToken } from "../../api";
import { AmountDivideByHundred } from "../../helper";
import { State as ListofStates } from 'country-state-city';
import { format } from "../../utils/timer";
import { useRef } from "react";
import PlaidLinkOpener from "../../utils/PlaidLinkOpener";
import useLocalStorageCleanup from "../../utils/useLocalStorageCleanup";
import addIcon from '../../assets/imgs/Add_Circled_Icon.svg';
import { DeleteOutlined } from "@ant-design/icons";
import { setCustomerDetails } from "../../redux/customerDetailsInfo";
import { useDispatch } from "react-redux";

const postalCodes = require('postal-codes-js');

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  paymentPagePay: Boolean,
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  alpha2: string,
  disableButtonText: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  showWhatsAppNotify: boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  tax: Number;
  discount: Number;
  totalPayable: Number,
  subTotal: Number,
  isBillingAdressRequired: Boolean,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  prefix: string,
  expireyText: String,
  count: Number,
  surcharge: Number,
  paymentLinkId: String,
  accountGid: String,
  isTest: Boolean,
}

const RapidWithPlaid = (props: Props) => {
  const { submit, preFillCustomer, customerDisabled, isBillingAdressRequired, paymentLinkId, isTest,
    buttonText, errorHeader, errorMsg, sitekey, isCaptchaEnabled, discount, paymentPagePay, plaidPublicToken, setPlaidPublicToken,
    customerValidation, alpha2, disableButtonText, planStartDate, currentDateObject, showCancelBtn, cancel, cancelButtonText,
    amount, serviceFeeVal, serviceFee, serviceFeeRate, tip, prefix, tax, totalPayable, subTotal, surcharge, accountGid,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, expireyText, count, customerFields } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [pinCode, setPinCode] = useState(null);
  const [billStatesList, setBillStatesList] = useState([{}]);
  const postalCode = 'Zip Code';
  const pincodeLabel = 'Zip Code';
  const [countryNameCode, setCountryNameCode] = useState();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [plaidOpen, setPlaidOpen] = useState(false);
  const [plaidAccessToken, setPlaidAccessToken] = useState(null);
  const [bankError, setBankError] = useState(null);
  useLocalStorageCleanup(`plaidPublicToken-${paymentLinkId}`);
  const dispatch = useDispatch();
  
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if(accountGid) {
      getPlaidToken({ id: accountGid, isTest })
      .then((entity) => {
          setPlaidAccessToken(entity?.token);
      });
    }
  }, [accountGid]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    watch,
  } = useForm();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);


  // THIS FUNCTIONALITY IS WRITTEN TO UPDATE THE CHANGED CUSTOMER VALES IN OTHER PAYMENT METHODS
  const watchedName = watch("name");
  const watchedEmail = watch("email");
  const watchedPhone = watch("phone");
  const watchedCallingCode = watch("countryCallingCode");

  const previousName = useRef();
  const previousEmail = useRef();
  const previousPhone = useRef();
  const previousCallingCode = useRef();

  // Combined effect for all three fields
  useEffect(() => {
    const hasNameChanged = watchedName !== previousName.current;
    const hasEmailChanged = watchedEmail !== previousEmail.current;
    const hasPhoneChanged = watchedPhone !== previousPhone.current;
    const hasCallingCodeChanged = watchedCallingCode !== previousCallingCode.current;

    if ((hasNameChanged || hasEmailChanged || hasPhoneChanged || hasCallingCodeChanged)) {
      previousName.current = watchedName;
      previousEmail.current = watchedEmail;
      previousPhone.current = watchedPhone;
      previousCallingCode.current = watchedCallingCode;

      const fullPhone = watchedCallingCode?.value
        ? `${watchedCallingCode.value}${watchedPhone || ""}`
        : watchedPhone || "";

      dispatch(setCustomerDetails({ name: watchedName, email: watchedEmail, phoneNumber: fullPhone }));
    }
  }, [watchedName, watchedEmail, watchedPhone, watchedCallingCode]);


  useEffect(() => {
    if (alpha2 && isBillingAdressRequired) {
      getDefaultCountryPostal();
    }
  }, [alpha2, isBillingAdressRequired]);

  useEffect(() => {
    reset({
      country: defaultCountry || "",
      zipCode: pinCode || "",
    })
  }, [pinCode]);

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = countryNameCode || (defaultCountry && defaultCountry.code);
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const getDefaultCountryPostal = async () => {
    try {
      const data = await getLocationDetails();
      const payLoad = {
        "name": data && data.country_name,
        "code": data && data.country
      }
      setDefaultCountry(payLoad);
      setPinCode(data && data.postal);
      const countryStates = ListofStates.getStatesOfCountry(data && data.country);
      setBillStatesList(countryStates);
    } catch (e) {
      console.log(e);
    }
  };

  const callBackStatelist = async (data) => {
    const countryStates = ListofStates.getStatesOfCountry(data && data.code);
    const payLoad = {
      "name": data && data.name,
      "code": data && data.code
    }
    setDefaultCountry(payLoad);
    reset({
      billstate: "",
      country: payLoad,
    })
    setBillStatesList(countryStates);
  }

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [preFillCustomer?.name, preFillCustomer?.email, preFillCustomer?.phoneNumber]);

  useEffect(() => {
      if (paymentPagePay) {
        const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
        const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
        if (defaultCountry) {
          reset({
            name: customerFields && customerFields.name || "",
            email: customerFields && customerFields.contactUsEmail || "",
            phone: phone && phone.nationalNumber || "",
            countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
            country: defaultCountry || "",
            zipCode: pinCode || "",
            billstate: "",
          })
        } else {
          reset({
            name: customerFields && customerFields.name || "",
            email: customerFields && customerFields.contactUsEmail || "",
            phone: phone && phone.nationalNumber || "",
            countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
            billstate: "",
          })
        }
      }
    }, [reset, customerFields]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      marginTop: '8px',
      width: '100%'
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important'
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important'
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important'
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      widht: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    if (alpha2 === 'US' && !plaidPublicToken) {
        setBankError(true);
        return;
    }
    const { name, email, phone, countryCallingCode, zipCode, country, postalCode, bankName, accountType, notify, accountNumber, routingNumber, accountHolderName, businessType } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const BankName = bankName ? bankName.trim() : null;
    const Name = accountHolderName ? accountHolderName.trim() : null;
    const Route = routingNumber ? routingNumber.trim() : null;
    const AccountNum = accountNumber ? accountNumber.trim() : null;
    const paymentMethod = {
      type: "ZIP_ACH", postalCode: postalCode ? postalCode : zipCode, countryCode: country && country.code, bank: { bankName: BankName, accountType: accountType?.value, accountNumber: AccountNum, routingNumber: Route, name: Name, plaidPublicToken: plaidPublicToken, businessType: businessType?.value },
      paymentMethodBillingAddress: isBillingAdressRequired ? {
        city: data.billcity || null, countryCode: (country && country.code) || null, state: (data.billstate && (data.billstate.isoCode === 'TG' ? 'TS' : (data.billstate.isoCode === 'UT' ? 'UK' : (data.billstate.isoCode === 'DH' ? 'DN' : data.billstate.isoCode)))) || null,
        street: data.billaddress ? `${data.billaddress}, ${data.billaddress1 || ''}` : null
      }
        : null,
    };
    const finalData = { ...data, phoneNumber, customer, notify, paymentMethod, recaptchaToken };
    console.log(finalData, 'finalData');
    if (submit) { submit(finalData) }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  };

  const customLabelStyle = {
    color: 'black'
  };

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    md: '47.5%',
    flexDirection: 'col',
  };

  const customSubmitButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' : '30%'),
    backgroundColor: '#0b64bc',
    height: 'auto',
    margin: '0px',
    padding: '5px 0',
  };

  const customAddBankButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '34%'),
    backgroundColor: '#ffffff',
    borderColor: '#0b64bc',
    borderStyle: 'solid',
    borderWidth: '1px',
    color: '#0b64bc',
    height: '36px',
    margin: '0px',
    fontSize: '15px',
    fontWeight: '600'
  };

  const customCancelButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '30%'),
    background: '#e53935',
    height: '43px',
    color: 'white',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingTop: '0px',
    fontSize: '20px',
  }

  const removeToken = () => { 
    setPlaidPublicToken(undefined);
    localStorage.removeItem(`plaidPublicToken-${paymentLinkId}`) 
  };

  const isFormValid = () => {
    // Get current form values
    const formValues = watch();
    
    // Customer Details validation
    const customerValid = customerValidation ? (
        formValues.name &&
        formValues.email &&
        formValues.phone &&
        formValues.countryCallingCode
    ) : true;

    // Bank Details validation for India
    const bankDetailsValid = alpha2 === 'IN' ? (
        formValues.bankName &&
        formValues.accountType &&
        formValues.accountHolderName &&
        formValues.accountNumber &&
        formValues.routingNumber
    ) : true;

    // Plaid validation for US
    const plaidValid = alpha2 === 'US' ? (
      plaidPublicToken &&
      formValues.businessType
    ) : true;

    // Billing Details validation (if required)
    const billingValid = isBillingAdressRequired && defaultCountry ? (
        formValues.billaddress &&
        formValues.billcity &&
        formValues.billstate &&
        formValues.zipCode &&
        formValues.country
    ) : true;

    // Return overall validation
    return customerValid && bankDetailsValid && plaidValid && billingValid;
  };

  return (
    <>
      {
        expireyText && (
          <p 
            style={{
              width: '100%',
              display: 'flex'
            }}
            className="px-4 pb-2 px-md-4"
          >
            <section>
              {expireyText} 
              <span style={{ 
                  fontWeight: "600",
                  marginLeft: "3px",
                }}
              >
                {format(count)}
              </span>
            </section>
          </p>
        )
      }
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        onChange={() => setShowErrorMessage(false)}
        style={{
          width: '100%',
        }}
      >
        <div className="px-4 pb-4 px-md-4 mt-2">
          <FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">CUSTOMER DETAILS</PH3Text>
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Name <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.name ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="name"
                  placeholder="Enter your name"
                  rules={customerValidation && {
                    required: 'This field is required'
                  }}
                  as={<Input
                      readOnly={customerDisabled}
                      style={{
                        ...customInputStyle,
                        background: customerDisabled ? BACKGROUND_COLOR : customInputStyle?.background,
                        color: customerDisabled ? COLOR : customInputStyle?.color,
                      }}
                  />}
                />
                <ErrorMessage
                  errors={errors}
                  name="name"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>E-mail <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  marginBottom="0px"
                  defaultValue={""}
                  color={errors.email ? "red" : "inherit"}
                  control={control}
                  name="email"
                  placeholder="Enter your email address"
                  rules={customerValidation && {
                    required: 'This field is required',
                    pattern: {
                      value: EMAIL.DEFAULT_REGEX,
                      message: 'The email is invalid',
                    },
                  }}
                  as={<Input
                    readOnly={customerDisabled}
                    style={{
                      ...customInputStyle,
                      background: customerDisabled ? BACKGROUND_COLOR : customInputStyle?.background,
                      color: customerDisabled ? COLOR : customInputStyle?.color,
                    }}
                  />}
                />
                <ErrorMessage
                  errors={errors}
                  name="email"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Phone <span style={{ color: 'red' }}>*</span></LabelText>
                <InputWrapper 
                  className="row" 
                  display="flex" 
                  marginTop="8px" 
                  borderRadius="4px" 
                  style={{
                    ...customInputStyle,
                    background: customerDisabled ? BACKGROUND_COLOR : customInputStyle?.background,
                    color: customerDisabled ? COLOR : customInputStyle?.color,
                  }}
                >
                  <Controller
                    defaultValue={""}
                    color={errors.countryCallingCode ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="countryCallingCode"
                    placeholder="select"
                    rules={customerValidation && {
                      required: 'Calling Code is required'
                    }}
                    as={<Select
                      menuPlacement="auto"
                      isSearchable={!customerDisabled}
                      menuIsOpen={customerDisabled ? false : undefined}
                      getOptionLabel={(option) => option.value}
                      styles={customerDisabled ? disableStyles : phoneCustomStyles}
                      options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                  />
                  <Controller
                    className="col"
                    defaultValue={""}
                    color={errors.phone ? "red" : "inherit"}
                    border="0px !important"
                    marginBottom="0px"
                    marginTop="0px"
                    marginLeft="0px"
                    paddingRight="0"
                    control={control}
                    name="phone"
                    rules={customerValidation && {
                      required: 'This field is required',
                      validate: isPhoneNumberValidate
                    }}
                    as={<NumberFormat
                      type="tel"
                      allowNegative={false}
                      decimalScale={0}
                      readOnly={customerDisabled}
                      borderRadius="none"
                      style={{
                        ...customInputStyle,
                        background: customerDisabled ? BACKGROUND_COLOR : customInputStyle?.background,
                        color: customerDisabled ? COLOR : customInputStyle?.color,
                        height: '39px',
                      }}
                    />}
                    placeholder="Enter your phone number"
                    customInput={Input}
                  />
                </InputWrapper>
                <ErrorMessage
                  errors={errors}
                  name="phone"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              {
                sitekey && (isCaptchaEnabled === true) && (
                  <div className="mt-3">
                    <ReCAPTCHA
                      sitekey={sitekey}
                      value={recaptchaToken}
                      onChange={(value) => {
                        setRecaptchToken(value);
                        setShowCaptchError(null);
                      }}
                    />
                    {
                      (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                      ) : showCaptchError ? (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                      ) : ''
                    }
                  </div>
                )
              }
            </FlexContainer>
            <Hr/>
            <FlexContainer {...customRowFlexContainerProps}>
              <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">BANK DETAILS <span style={{ color: 'red' }}>*</span></PH3Text>
            </FlexContainer>
            {alpha2 === 'IN' && (
            <>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Bank Name <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.bankName ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="bankName"
                  placeholder="Enter bank name"
                  rules={{
                    required: 'This field is required',
                    pattern: {
                      value: /^[a-zA-Z ]+$/,
                      message: 'Bank name must be valid',
                    },
                  }}
                  as={
                    <Input
                      style={customInputStyle}
                    />
                  }
                />
                <ErrorMessage
                  errors={errors}
                  name="bankName"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Account Type <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.accountType ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="accountType"
                  placeholder="select"
                  rules={{
                    required: 'Account type is required'
                  }}
                  as={<Select
                    className="px-0 border-0"
                    getOptionLabel={(option) => option.value}
                    styles={customStyles}
                    options={ACCOUNT_TYPES.map(value => { return { value } })} />}
                />
                <ErrorMessage
                  errors={errors}
                  name="accountType"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Account Holder Name <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.accountHolderName ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="accountHolderName"
                  placeholder="Enter account holder name"
                  rules={{
                    required: 'This field is required',
                    pattern: {
                      value: /^[a-zA-Z ]+$/,
                      message: 'Account holder name must be valid',
                    },
                  }}
                  as={<Input style={customInputStyle}/>}
                />
                <ErrorMessage
                  errors={errors}
                  name="accountHolderName"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Bank Account Number <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.accountNumber ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="accountNumber"
                  placeholder="Enter account number"
                  rules={{
                    required: 'This field is required',
                    pattern: {
                      value: /^\s*[0-9]{6,17}\s*$/,
                      message: 'The account number is invalid',
                    },
                  }}
                  as={<Input style={customInputStyle}/>}
                />
                <ErrorMessage
                  errors={errors}
                  name="accountNumber"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer {...customColFlexContainerProps}>
                <LabelText style={customLabelStyle}>Routing Number <span style={{ color: 'red' }}>*</span></LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.routingNumber ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="routingNumber"
                  placeholder="Enter routing number"
                  rules={customerValidation && {
                    required: 'This field is required',
                    pattern: {
                      value: /^\s*[0-9]{9}\s*$/,
                      message: 'The routing number is invalid',
                    },
                  }}
                  as={<Input style={customInputStyle}/>}
                />
                <ErrorMessage
                  errors={errors}
                  name="routingNumber"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </FlexContainer>
            </FlexContainer>
            </>
            )}
            <FlexContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} {...customRowFlexContainerProps}>
                {!plaidPublicToken
                  ? (
                      <>
                        <SubmitButton style={customAddBankButtonStyle} onClick={(e) => { setPlaidOpen(true); e.preventDefault(); }}>
                          <img style={{ verticalAlign: "sub" }} src={addIcon} alt="addIcon" /> Add Bank Account
                        </SubmitButton>
                        {bankError && !plaidPublicToken && <Text fontSize="12px" marginTop="10px" marginBottom="0px" color="#ff1e1e">Bank is required!</Text>}
                      </>
                    )
                  : (
                      <>
                        <FlexContainer {...customColFlexContainerProps} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <Tag color="green">Bank Account Added</Tag>
                          <Tooltip title="Remove Bank">
                            <DeleteOutlined style={{ color: '#6b6c6f', fontSize: '18px', cursor: 'pointer' }} onClick={removeToken} />
                          </Tooltip>
                        </FlexContainer>
                        <FlexContainer {...customColFlexContainerProps}>
                          <LabelText style={customLabelStyle}>Business Type <span style={{ color: 'red' }}>*</span></LabelText>
                          <Controller
                            defaultValue={""}
                            color={errors.billstate ? "red" : "inherit"}
                            marginBottom="0px"
                            marginTop="8px"
                            border="0px !important"
                            control={control}
                            name="businessType"
                            placeholder="Business Type"
                            rules={{
                              required: 'Business Type is required'
                            }}
                            as={<Select
                              menuPlacement="auto"
                              styles={customStyles}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              options={PLAID_BUSINESS_TYPES} />}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="businessType"
                            render={({ message }) => (
                              <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                            )}
                          />
                        </FlexContainer>
                      </>
                    )
                }
            </FlexContainer>
            {
              isBillingAdressRequired ?
              (
                <>
                  <Hr />
                  { defaultCountry && 
                    (
                      <>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">BILLING DETAILS</PH3Text>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="100%">
                            <LabelText style={customLabelStyle}>Address Line 1 <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.billaddress ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billaddress"
                              placeholder="Address"
                              rules={{
                                required: 'Address is required',
                              }}
                              as={<Input style={customInputStyle}/>}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billaddress"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="63.3%">
                            <LabelText style={customLabelStyle}>Address Line 2</LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.billaddress1 ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billaddress1"
                              placeholder="Address2"
                              as={<Input style={customInputStyle}/>}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billaddress1"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="31.6%">
                            <LabelText style={customLabelStyle}>City <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.billcity ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="billcity"
                              placeholder="City"
                              rules={{
                                required: 'City is required',
                              }}
                              as={<Input style={customInputStyle}/>}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billcity"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                        <FlexContainer {...customRowFlexContainerProps}>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={customLabelStyle}>State <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              defaultValue={""}
                              color={errors.billstate ? "red" : "inherit"}
                              marginBottom="0px"
                              marginTop="8px"
                              border="0px !important"
                              control={control}
                              name="billstate"
                              placeholder="State"
                              rules={{
                                required: 'State is required'
                              }}
                              as={<Select
                                menuPlacement="auto"
                                styles={customStyles}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.isoCode}
                                options={billStatesList} />}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billstate"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={customLabelStyle}>{pincodeLabel} <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              marginTop="8px !important"
                              marginBottom="0px"
                              defaultValue={""}
                              color={errors.zipCode ? "red" : "inherit"}
                              control={control}
                              name="zipCode"
                              isSearchable="true"
                              placeholder={postalCode}
                              rules={{
                                required: `${pincodeLabel} is required`,
                                validate: isZipcodeValidate1
                              }}
                              as={
                                <Input 
                                  style={customInputStyle}
                                  type="text"
                                  name="zipCode"
                                  // onInput={event => {
                                  //   getCountryCode(event.target.value);
                                  // }}
                                  placeholder="Enter your card number"
                                />
                              }
                              customInput={Input}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="zipCode"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="billzipCode"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                          <FlexContainer {...customColFlexContainerProps} md="30%">
                            <LabelText style={customLabelStyle}>Country <span style={{ color: 'red' }}>*</span></LabelText>
                            <Controller
                              defaultValue={''}
                              color={errors.country ? "red" : "inherit"}
                              marginBottom="0px"
                              control={control}
                              name="country"
                              placeholder="Select a country"
                              rules={{
                                required: 'Country is required'
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  className="px-0 border-0"
                                  // theme={(theme) => ({
                                  //   ...theme,
                                  //   borderRadius: '4px',
                                  //   boxShadow: 0,
                                  // })}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.code}
                                  styles={customStyles}
                                  options={COUNTRIES_LIST}
                                  defaultValue={defaultCountry}
                                  placeholder="Country"
                                  onChange={(event) => {
                                    callBackStatelist(event);
                                    setCountryNameCode(event.code);
                                  }}
                                />
                              )}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="country"
                              render={({ message }) => (
                                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                              )}
                            />
                          </FlexContainer>
                        </FlexContainer>
                      </>
                    )
                  }
                </>
              ) : ''
            }
            <FlexContainer {...customRowFlexContainerProps}>
              {
                (serviceFeeEnabled === true) && (
                  // <div className="px-1 px-md-4">
                    <div class="mt-4" style={{width: '100%'}}>
                      <table class="table table-bordered mt-4">
                        <tbody>
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Amount:</th>
                            <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                          </tr>
                          <tr style={{ borderBottom: 'hidden' }}>
                            <th scope="row">Service Fee:</th>
                            <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                          </tr>
                          <tr style={{ background: '#F7F7F7' }}>
                            <th scope="row">Total Payable:</th>
                            <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  // </div>
                )
              }
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              {
                (serviceFee || serviceFeeRate || discount || subTotal) && (
                  <div class="mt-4" style={{width: '100%'}}>
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Amount:</th>
                          <td>{prefix} {AmountDivideByHundred(amount)}</td>
                        </tr>
                        {
                          discount && discount !== 0 ? (
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Discount:</th>
                              <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        {
                          subTotal && subTotal !== 0 ? (
                            <tr>
                              <th scope="row">Sub Total:</th>
                              <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        {
                          tax && tax !== 0 ? (
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Tax:</th>
                              <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        {
                          serviceFeeVal && serviceFeeVal !== 0 ? (
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Service Fee:</th>
                              <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        {
                          surcharge && surcharge !== 0 ? (
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Surcharge:</th>
                              <td>{prefix} {AmountDivideByHundred(surcharge)}</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        {
                          tip && tip !== 0 ? (
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Tip:</th>
                              <td>{prefix} {AmountDivideByHundred(tip)}</td>
                            </tr>
                          ) : (
                            <></>
                          )
                        }
                        <tr style={{ background: '#F7F7F7' }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              }
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              {!isFormValid() && (
                <Alert className="mt-3 w-100" message="⚠️ Please fill all required fields to continue" type="error" />
              )}
            </FlexContainer>
            <FlexContainer {...customRowFlexContainerProps}>
              <FlexContainer
                width="100%"
                marginTop="5%"
                alignItems="center"
                justifyContent={screenWidth < TABLET_SCREEN_WIDTH ? 
                  "space-evenly" : 
                  ((showCancelButton && cancel) ? 
                  "space-evenly":
                  "flex-start"
                  )
                }
              >
                {
                  (showCancelButton && cancel) &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    // color="#40A9FF"
                    className="cursor-pointer"
                    style={customCancelButtonStyle}
                  >
                    {cancelButtonText || "Cancel"}
                  </SpanText>
                }
                { (disableButtonText && (planStartDate < currentDateObject)) ?
                  (
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled
                    >
                      {buttonText || "PAY"}
                    </SubmitButton>
                  )
                  : (
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled={!isFormValid()}
                    >
                      {buttonText || "PAY"}
                    </SubmitButton>
                  )
                }
              </FlexContainer>
              <div className={isShowErrorMessage &&"mt-3"}>
                {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />} */}
              </div>
                {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
            </FlexContainer>
          </FlexContainer>
        </div>
      </form>
      {plaidOpen && !plaidPublicToken && (
        <PlaidLinkOpener
          token={plaidAccessToken}
          onClose={() => window.location = window.location.href}
          onSuccess={(public_token, metadata) => {
            localStorage.setItem(`plaidPublicToken-${paymentLinkId}`, public_token);
            setPlaidPublicToken(public_token);
          }}
        />
      )}
    </>
  )
};

export default RapidWithPlaid;
